<!-- <section class="sec-mr wrap-small-card">
  <div class="sec-title"> Latest Industry Reports</div>
  <div *ngFor="let industry of industryList">
    <app-industry-report-suggestion-card [report]="industry"></app-industry-report-suggestion-card>
  </div>
  <div *ngIf="!(industryList.length > 0)">
    No Reports to show
  </div>
</section>

<section class="sec-mr wrap-small-card">
  <div class="sec-title">Weekly Funding Reports</div>
  <div *ngFor="let industry of fundingList">
    <app-industry-report-suggestion-card report]="industry"></app-industry-report-suggestion-card>
  </div>
  <div *ngIf="!(fundingList.length > 0)">
    No Reports to show
  </div>
</section> -->
<app-industry-report-suggestion></app-industry-report-suggestion>
